<template>
  <div>
    <h3 class="subtitle is-bold">Other Team Member(s) Details</h3>
    <div
      class="column"
      v-for="(x, index) in [].constructor(teamsize)"
      :key="index"
    >
      <h3 class="subtitle">Team Member {{ index + 2 }}</h3>
      <div class="control">
        <ValidationProvider
          :name="`Team Member ${index + 2} First Name`"
          rules="required"
          v-slot="{ errors }"
        >
          <b-field
            label="First Name"
            :type="{ 'is-danger': errors.length > 0 }"
            :message="errors[0]"
          >
            <b-input v-model="teammembers[index].firstname" />
          </b-field>
        </ValidationProvider>
      </div>
      <div class="control">
        <ValidationProvider
          :name="`Team Member ${index + 2} Surname`"
          rules="required"
          v-slot="{ errors }"
        >
          <b-field
            label="Surname"
            :type="{ 'is-danger': errors.length > 0 }"
            :message="errors[0]"
          >
            <b-input v-model="teammembers[index].surname" />
          </b-field>
        </ValidationProvider>
      </div>
      <div class="control">
        <ValidationProvider
          :name="`Team Member ${index + 2} Email Address`"
          rules="required|email"
          v-slot="{ errors }"
        >
          <b-field
            label="Email Address"
            :type="{ 'is-danger': errors.length > 0 }"
            :message="errors[0]"
          >
            <b-input v-model="teammembers[index].email" />
          </b-field>
        </ValidationProvider>
      </div>
      <div class="control">
        <GenderSelect
          :label="`Team Member ${index + 2} Gender`"
          rules="required"
          v-model="teammembers[index].gender"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GenderSelect from "@/components/GenderSelect";

export default {
  components: {
    GenderSelect,
  },
  props: {
    teammembers: {
      type: Array,
      default: () => [],
    },
    teamsize: {
      type: Number,
      default: 0,
    },
    event: {
      type: Object,
      default: null,
    },
  },
};
</script>